// src/components/ProtectedRoute.tsx

import { useEffect, useState } from 'react'
import { useAuth } from '../context/auth-context'
import { useNavigate } from 'react-router-dom'
import { Layout } from '../layout'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isInitialized } = useAuth()
  const navigate = useNavigate()
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    if (isInitialized && !isAuthenticated && !isRedirecting) {
      setIsRedirecting(true)

      navigate('/signin')

      const fallbackTimer = setTimeout(() => {
        if (window.location.pathname !== '/signin') {
          window.location.href = '/signin'
        }
      }, 100)

      return () => clearTimeout(fallbackTimer)
    }
  }, [isInitialized, isAuthenticated, navigate, isRedirecting])

  if (!isInitialized) {
    return (
      <div
        className='flex justify-content-center align-items-center'
        style={{ height: '100dvh' }}
      >
        <i
          className='pi pi-spin pi-spinner'
          style={{ fontSize: '2rem' }}
        ></i>
        <span className='ml-2'>Carregando...</span>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div
        className='flex justify-content-center align-items-center'
        style={{ height: '100dvh' }}
      >
        <i
          className='pi pi-spin pi-spinner'
          style={{ fontSize: '2rem' }}
        ></i>
        <span className='ml-2'>Redirecionando para login...</span>
      </div>
    )
  }

  return <Layout>{children}</Layout>
}
